import {takeLatest, put} from 'redux-saga/effects';
import {
  CREATE_PROVIDER,
  CREATE_PROVIDER_FAILED,
  CREATE_PROVIDER_SUCCESS,
  GET_PROVIDERS,
  GET_PROVIDERS_FAILED,
  GET_PROVIDERS_SUCCESS,
  UPDATE_PROVIDER_STATUS,
  UPDATE_PROVIDER_STATUS_FAILED,
  UPDATE_PROVIDER_STATUS_SUCCESS,
} from './constants';

import {
  CreateProviderRequestBuilder,
  GetProvidersBuilder,
  GetProvidersCountBuilder,
  UpdateProviderStatusRequestBuilder,
} from 'client-sdk/src/providers/providers';

import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import {flattenObject} from '../../utils/helpers';
import handleNotfication from '../../utils/handleNotfication';

const token = localStorage.getItem('token') || '';

export function* getProviders(actions: any): unknown {
  try {
    const makeRequest = new GetProvidersBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetProvidersCountBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeActiveCardCountRequest = new GetProvidersCountBuilder()
      .params(
        flattenObject({
          ...actions.payload,
          sort: 'id,desc',
          'status.in': ['ACTIVE'],
        })
      )
      .build();
    const makeInactiveCardCountRequest = new GetProvidersCountBuilder()
      .params(
        flattenObject({
          ...actions.payload,
          sort: 'id,desc',
          'status.in': ['INACTIVE'],
        })
      )
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    const count = yield client.execute(makeCountRequest);
    const activeCardCount = yield client.execute(makeActiveCardCountRequest);
    const inactiveCardCount = yield client.execute(
      makeInactiveCardCountRequest
    );
    yield put({
      type: GET_PROVIDERS_SUCCESS,
      data: response.data,
      count: count.data,
      activeCardCount: activeCardCount.data,
      inactiveCardCount: inactiveCardCount.data,
    });
  } catch (error) {
    yield put({
      type: GET_PROVIDERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateProviderStatus(actions: any): unknown {
  try {
    const {id, body, pagination} = actions.payload;
    const makeUpdateProviderStatusRequest = new UpdateProviderStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeUpdateProviderStatusRequest);
    yield put({
      type: UPDATE_PROVIDER_STATUS_SUCCESS,
    });
    yield put({
      type: GET_PROVIDERS,
      payload: {...pagination, sort: 'id, desc'},
    });
    handleNotfication('وضعیت تامین کننده با موفقیت تغییر پیدا کرد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_PROVIDER_STATUS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* createProvider(actions: any): unknown {
  try {
    const {body, pagination, callback} = actions.payload;
    const makeAddProviderRequest = new CreateProviderRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeAddProviderRequest);
    yield put({
      type: CREATE_PROVIDER_SUCCESS,
    });
    yield put({
      type: GET_PROVIDERS,
      payload: {...pagination, sort: 'id, desc'},
    });
    callback();
    handleNotfication('تامین کننده با موفقیت اضافه شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_PROVIDER_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* providerSaga() {
  yield takeLatest(GET_PROVIDERS, getProviders);
  yield takeLatest(UPDATE_PROVIDER_STATUS, updateProviderStatus);
  yield takeLatest(CREATE_PROVIDER, createProvider);
}
